import * as React from 'react';
import type { SVGProps } from 'react';

const IconTI = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 44" {...props}>
    <path
      d="M32 33.352H0v10.17h32v-10.17ZM10.236 10.294v15.357l11.528 7.697V10.294H32V.124H0v10.17h10.236Z"
      fill="currentColor"
    />
  </svg>
);
export default IconTI;
